import Vue from 'vue'
import objectToFormData from 'object-to-formdata'

const initialState = {
  searchResults: [],
  departmentsTree: [],
  departmentEmployeesData: {
    employees: []
  },
  employeeDetail: {},
  loading: false
}

export default {
  namespaced: true,
  state: {
    ...initialState
  },
  getters: {
    departmentEmployees(state) {
      return state.departmentEmployeesData.employees.sort((a, b) => a - b)
    }
  },
  mutations: {
    SET(state, data) {
      state[data.key] = data.val
    },
    CLEAR(state, key = false) {
      if (key)
        state[key] = initialState[key]
      else state = {...initialState}
    },
    REMOVE_TELEGRAM_SESSION(state, sessionId) {
      state.employeeDetail = {
        ...state.employeeDetail,
        telegram_chats: state.employeeDetail.telegram_chats.filter((session) => session.id !== sessionId)
      }
    }
  },
  actions: {
    search({commit, state}, {q, scope}) {
      return new Promise((resolve, reject) => {
        let scopeAll = scope ? '&scope=all' : ''
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`reference/employees/search/?q=${q}${scopeAll}`, { __silent: true }).then(response => {
          commit('SET', {key: 'searchResults', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getDepartmentsTree({commit}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`reference/departments/tree/`).then(response => {
          commit('SET', {key: 'departmentsTree', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getDepartmentEmployees({commit}, departmentId) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`reference/departments/tree/${departmentId}/employees/`).then(response => {
          commit('SET', {key: 'departmentEmployeesData', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    read({commit}, employeeId) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`account/${employeeId}/`).then(response => {
          commit('SET', {key: 'employeeDetail', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    readAccountData({commit}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`account/relations/`).then(response => {
          commit('SET', {key: 'employeeDetail', val: response.data.instance})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    update({commit}, employee) {
      if (!employee.photo) delete employee.photo
      let data = objectToFormData(employee)
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.patch(`account/`, data, {
          headers: {'Content-Type': 'multipart/form-data'}
        }).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    removeTelegramSession({commit, state}, sessionId) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.delete(`account/${state.employeeDetail.id}/telegram_sessions/${sessionId}/`).then(() => {
          commit('REMOVE_TELEGRAM_SESSION', sessionId)
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    }
  }
}
